import React, { useEffect, useState } from "react";
import "./status.style.sass";
import { Button, Col, List, Modal, Row } from "rsuite";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectStatusModal } from "../../redux/modals/modals.selector";
import modalsTypes from "../../redux/modals/modals.types";
import {
	selectCarsData,
	selectHoldOverCars,
	selectIsWithOutPoint,
	selectSelectedCarInfo,
	selectSingleCarData,
} from "../../redux/cars/cars.selector";
import {
	AddCarToHoldOverCars,
	SetHoldOverCars,
} from "../../redux/cars/cars.action";
import { BiggerTime, ToPersian, ToPersianDate } from "../../script";
import { selectUserInfo } from "../../redux/user/user.selector";

const StatusComponent = (props) => {
	const {
		statusModal,
		ToggleStatus,
		cardata,
		ToggleDrawer,
		singleCarData,
		isWithOutPoint,
		setHoldOver,
		getUser,
	} = props;
	console.log({ getUser });
	const [voltVahed, setVoltVahed] = useState("ولت");
	const [Data, setData] = useState([]);
	const [params, setParams] = useState();
	useEffect(() => {
		let paramsUrl = new URLSearchParams(document.URL);
		setParams(Object.fromEntries(paramsUrl));
	}, [document.URL]);
	// SHOW FUNCTION
	const operator = (Operator) => {
		switch (Operator) {
			case 1:
				return "همراه اول";
			case 2:
				return "ایرانسل";
			case 3:
				return "رایتل";
			default:
				return "نا مشخص";
		}
	};
	const BatteryStatus = (status, battery) => {
		switch (status) {
			case 0:
				if (battery > 4) {
					return "باتری درحال شارژ";
				} else {
					return "درحال تخلیه";
				}
			case 1:
				return "فول شارژ";
			default:
				return "نا معتبر";
		}
	};
	const SwitchStatus = (Switch) => {
		return Switch ? "باز" : "بسته";
	};
	const Tempt = (t) => {
		return `℃ ${t}`;
	};
	const Speed = (s) => {
		return s ? `${s} کیلومتر` : "ثابت";
	};
	const Door = (d) => {
		return d ? "باز" : "بسته";
	};
	let lastDate = "";

	if (singleCarData) {
		lastDate =
			BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) * 1000;
	} else {
		lastDate =
			BiggerTime(isWithOutPoint.SimDebitLastUpdate, isWithOutPoint.Time) * 1000;
	}

	useEffect(() => {
		if (!!singleCarData) {
			setData([
				{
					id: 1,
					title: "نسخه نرم‌افزار :",
					data:
						cardata.FrameworkVersion >= 110 && cardata.FrameworkVersion <= 199
							? `ردیاب (${cardata.FrameworkVersion})`
							: cardata.FrameworkVersion >= 210 &&
							  cardata.FrameworkVersion <= 299
							? `دزدگیر ردیاب (${cardata.FrameworkVersion})`
							: cardata.FrameworkVersion >= 310 &&
							  cardata.FrameworkVersion <= 399
							? `ردیاب موتورسیکلت (${cardata.FrameworkVersion})`
							: cardata.FrameworkVersion >= 710 &&
							  cardata.FrameworkVersion <= 799
							? `ردیاب obd (${cardata.FrameworkVersion})`
							: cardata.FrameworkVersion >= 810 &&
							  cardata.FrameworkVersion <= 899
							? `دزدگیر اماکن (${cardata.FrameworkVersion})`
							: cardata.FrameworkVersion >= 910 &&
							  cardata.FrameworkVersion <= 999
							? `ردیاب آهنربایی (${cardata.FrameworkVersion})`
							: `نامشخص (${cardata.FrameworkVersion})`,
				},
				{
					id: 2,
					title: "شماره IMEI دستگاه :",
					data: cardata.IMEI,
				},
				{
					id: 3,
					title: "میزان شارژ سیم‌کارت :",
					data: cardata.SimDebit,
				},
				{
					id: 4,
					title: "آخرین ارسال داده :",
					data: new Date(lastDate).toLocaleTimeString("fa-IR", {
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						formatMatcher: "basic",
					}),
				},
				{
					id: 5,
					title: "تاریخ فعال‌سازی :",
					data: ToPersian(ToPersianDate(cardata.CreatedTime)),
				},
				{
					id: 6,
					title: "تاریخ انقضا :",
					data: ToPersian(ToPersianDate(cardata.ExpTime)),
					Click: true,
				},
				{
					id: 8,
					title: "سرعت فعلی :",
					data: Speed(cardata.Speed),
				},
				{
					id: 9,
					title: "دما فعلی :",
					data: Tempt(cardata.Temperature),
				},
				{
					id: 10,
					title: "وضعیت باتری (برق) :",
					data: cardata.Battery,
				},
				{
					id: 13,
					title: "نام اپراتور :",
					data: operator(cardata.Operator),
				},
			]);
		}
	}, [singleCarData]);

	useEffect(() => {
		if (!!isWithOutPoint) {
			setData([
				{
					id: 1,
					title: "نسخه نرم‌افزار :",
					data: isWithOutPoint.FrameworkVersion,
				},
				{
					id: 2,
					title: "شماره IMEI دستگاه :",
					data: isWithOutPoint.IMEI,
				},
				{
					id: 3,
					title: "میزان شارژ سیم‌کارت :",
					data: isWithOutPoint.SimDebit,
				},
				{
					id: 4,
					title: "آخرین ارسال داده :",
					data: new Date(lastDate).toLocaleTimeString("fa-IR", {
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						formatMatcher: "basic",
					}),
				},
				{
					id: 5,
					title: "تاریخ فعال‌سازی :",
					data: ToPersianDate(isWithOutPoint.CreatedTime),
				},
				{
					id: 6,
					title: "تاریخ انقضا :",
					data: ToPersianDate(isWithOutPoint.ExpTime),
					Click: true,
				},
				{
					id: 7,
					title: "وضعیت درب ها :",
					data: Door(isWithOutPoint.Door),
				},
				{
					id: 8,
					title: "سرعت فعلی :",
					data: Speed(isWithOutPoint.Speed),
				},
				{
					id: 9,
					title: "دما فعلی :",
					data: Tempt(isWithOutPoint.Temperature),
				},
				{
					id: 10,
					title: "وضعیت سوییچ :",
					data: SwitchStatus(isWithOutPoint.Switch),
				},
				{
					id: 11,
					title: "نام اپراتور :",
					data: operator(isWithOutPoint.Operator),
				},
			]);
		}
	}, [isWithOutPoint]);

	useEffect(() => {
		console.log("IM FIRE : ", Data);
		if (!!Data.length) {
			let version =
				parseInt(cardata.FrameworkVersion) ||
				parseInt(isWithOutPoint.FrameworkVersion);
			let Version;
			if (!!cardata && !!version) {
				if (900 < version && version < 999) {
					Version = 3;
					setVoltVahed("درصد");
				} else if (700 < version && version < 799) {
					console.log("IM setVoltVahed : ");
					Version = 2;
					setVoltVahed("ولت");
				} else {
					Version = 1;
					setVoltVahed("ولت");
				}
			}
			let NewData = Data;
			if (Version === 1) {
				let addData = [
					{
						id: 11,
						title: "وضعیت سوییچ :",
						data: SwitchStatus(cardata.Switch),
					},
					{
						id: 12,
						title: "شارژ باتری پشتیبان :",
						data: BatteryStatus(cardata.BatteryStatus, cardata.Battery),
					},
					{
						id: 7,
						title: "وضعیت درب ها :",
						data: Door(cardata.Door),
					},
				];

				addData.forEach((item) => NewData.push(item));
				setData(NewData.sort((a, b) => a.id - b.id));
			} else if (Version === 2) {
				let addData = [
					{
						id: 11,
						title: "وضعیت سوییچ :",
						data: SwitchStatus(cardata.Switch),
					},
					{
						id: 12,
						title: "شارژ باتری پشتیبان :",
						data: BatteryStatus(cardata.BatteryStatus, cardata.Battery),
					},
				];
				addData.forEach((item) => NewData.push(item));
				setData(NewData.sort((a, b) => a.id - b.id));
			} else {
				setData(Data.sort((a, b) => a.id - b.id));
			}
		}
	}, [Data]);

	const handleHoldOverDrawer = () => {
		setHoldOver([cardata.ID]);
		ToggleDrawer();
	};
	console.log(params);
	return (
		<div>
			<Modal
				size="xs"
				show={statusModal}
				onHide={() => ToggleStatus()}
			>
				<Modal.Header>
					<Modal.Title>
						وضعیت {cardata ? cardata.NAME : isWithOutPoint.NAME}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<List hover>
						{Data.map((item) => (
							<List.Item
								key={item.id}
								onClick={item.Click ? () => handleHoldOverDrawer() : null}
								style={item.Click ? { cursor: "pointer" } : null}
							>
								<Row>
									<Col xs={12}>
										{item.data}{" "}
										{item.title === "وضعیت باتری (برق) :" && voltVahed}
									</Col>
									<Col
										xs={12}
										style={{ textAlign: "right" }}
									>
										{item.title}
									</Col>
								</Row>
							</List.Item>
						))}
					</List>
				</Modal.Body>
				<Modal.Footer>
					<Row>
						<Col xs={12}>
							<Button
								block
								className="BtnClose"
								onClick={() => ToggleStatus()}
							>
								بستن
							</Button>
						</Col>
						<Col xs={12}>
							<Button
								block
								disabled={getUser?.phone === " 989190191914" ? true : false}
								className={getUser?.phone === " 989190191914" ? "btn1" : ""}
								onClick={() =>
									!(getUser?.phone === " 989190191914") &&
									handleHoldOverDrawer()
								}
							>
								تمدید پنل
							</Button>
						</Col>
					</Row>
				</Modal.Footer>
			</Modal>
		</div>
	);
};

const mapStateToProps = createStructuredSelector({
	statusModal: selectStatusModal,
	cardata: selectSelectedCarInfo,
	holdOverCars: selectHoldOverCars,

	getUser: selectUserInfo,
	carsData: selectCarsData,
	singleCarData: selectSingleCarData,
	isWithOutPoint: selectIsWithOutPoint,
});

const mapDispatchToProps = (dispatch) => ({
	ToggleStatus: () => dispatch({ type: modalsTypes.TOGGLE_STATUS_MODAL }),
	ToggleDrawer: () => dispatch({ type: modalsTypes.TOGGLE_DRAWER }),
	addToHoldOverCars: (car) => dispatch(AddCarToHoldOverCars(car)),
	setHoldOver: (id) => dispatch(SetHoldOverCars(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StatusComponent);
